let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1fEC8")).then(() => parcelRequire('l9FKp'));